import {Component, OnInit} from '@angular/core';
import {NewSpendingAccountService, SpendingAccount} from "../new-spending-account.service";

@Component({
    selector: 'brightside-web-spending-account-create',
    templateUrl: './spending-account-create.component.html',
    styleUrls: ['./spending-account-create.component.css'],
    standalone: false
})
export class SpendingAccountCreateComponent {


  constructor(
    private spendingSvc: NewSpendingAccountService
  ) { }

  ngOnInit(): void {
    this.spendingSvc.createAccount();
  }
}
